import { MOCK_KPIS, MOCK_PLANS } from './mockData/plans.mock'
import { MOCK_ALERTS } from './mockData/alerts.mock'
import { MOCK_ACTIVE_TASKS, MOCK_HORIZON_RESOURCES } from './mockData/tasks.mock'
import { MOCK_TRIGGERS } from './mockData/triggers.mock'
import {
  MOCK_RESOURCE_STATUS,
  MOCK_TEAM_MEMBERS,
  MOCK_MAINTENANCE_TASKS,
  MOCK_CAMP_TASKS,
  MOCK_SECURITY_TASKS,
  MOCK_MINING_TASKS,
} from './mockData/departments.mock'
import { MOCK_SHIFT_PROGRAMS } from './mockData/shiftPrograms.mock'
import { IDepartmentBoardTask } from './types/operations.types'

// Simulate async delay
const delay = (ms = 300) => new Promise((res) => setTimeout(res, ms))

// ============================================================
// Operation Plans
// ============================================================

export const getOperationPlans = async (_params?: any) => {
  // TODO: Replace with real API call when backend ships
  // return api.get('/v1/operation-plans', { params })
  await delay()
  return { data: MOCK_PLANS, totalCount: MOCK_PLANS.length, totalPages: 1 }
}

export const getSingleOperationPlan = async (id: string | number) => {
  // TODO: Replace with real API call
  // return api.get(`/v1/operation-plans/${id}`)
  await delay()
  const plan = MOCK_PLANS.find((p) => p.id === id)
  return plan || null
}

export const createOperationPlan = async (data: any) => {
  // TODO: Replace with real API call
  // return api.post('/v1/operation-plans', data)
  await delay(500)
  return { id: 'plan-new-' + Date.now(), ...data, status: 'Draft' }
}

export const activateOperationPlan = async (id: string | number) => {
  // TODO: Replace with real API call
  // return api.post(`/v1/operation-plans/${id}/activate`)
  await delay()
  return { success: true }
}

export const pauseOperationPlan = async (id: string | number) => {
  // TODO: Replace with real API call
  // return api.post(`/v1/operation-plans/${id}/pause`)
  await delay()
  return { success: true }
}

// ============================================================
// KPIs & Dashboard
// ============================================================

export const getOperationsKPIs = async () => {
  await delay()
  return MOCK_KPIS
}

export const getOperationalAlerts = async (_planId?: string | number) => {
  await delay()
  if (_planId) {
    return MOCK_ALERTS.filter((a) => a.planId === _planId || !a.planId).slice(0, 3)
  }
  return MOCK_ALERTS
}

// ============================================================
// Tasks & Horizon
// ============================================================

export const getActiveTasks = async (_planId?: string | number) => {
  await delay()
  if (_planId) {
    return MOCK_ACTIVE_TASKS.filter((t) => t.sourceId === _planId)
  }
  return MOCK_ACTIVE_TASKS
}

export const getHorizonResources = async () => {
  await delay()
  return MOCK_HORIZON_RESOURCES
}

export const getResourceStatus = async () => {
  await delay()
  return MOCK_RESOURCE_STATUS
}

export const getTeamMembers = async () => {
  await delay()
  return MOCK_TEAM_MEMBERS
}

// ============================================================
// Department Board
// ============================================================

const DEPT_TASK_MAP: Record<string, IDepartmentBoardTask[]> = {
  maintenance: MOCK_MAINTENANCE_TASKS,
  'camp-services': MOCK_CAMP_TASKS,
  security: MOCK_SECURITY_TASKS,
  'mining-operations': MOCK_MINING_TASKS,
}

export const getDepartmentTasks = async (departmentKey: string) => {
  await delay()
  return DEPT_TASK_MAP[departmentKey] || []
}

// ============================================================
// Triggers
// ============================================================

export const getTriggersList = async () => {
  await delay()
  return MOCK_TRIGGERS
}

export const toggleTrigger = async (id: string | number, enabled: boolean) => {
  await delay()
  return { id, enabled }
}

// ============================================================
// Shift Programs
// ============================================================

export const getShiftPrograms = async () => {
  await delay()
  return { data: MOCK_SHIFT_PROGRAMS, totalCount: MOCK_SHIFT_PROGRAMS.length, totalPages: 1 }
}

export const createShiftProgram = async (data: any) => {
  await delay(500)
  return { id: 'sp-new-' + Date.now(), ...data, status: 'Active' }
}
